import type {Exemplar, ExtendedDocument, Field, RichDocument} from 'typings/portaro.be.types';
import type {VolumeDataService} from '../kp-volumes/volume.data-service';
import type {LocalizationService} from '../../commons/providers/localization.provider';

export class KpDocumentMiniPresenter {

    /*@ngInject*/
    constructor(private CONTEXT_PATH: string, private volumeDataService: VolumeDataService, private localizationService: LocalizationService) {}
    public static presenterName = 'kpDocumentMiniPresenter';

    public getDocumentLink(document: RichDocument): string {
        return `${this.CONTEXT_PATH}/records/${document.id}`
    }

    public isExemplarVolumeMissing(exemplar: Exemplar): boolean {
        return exemplar.volumeId && !exemplar.volume;
    }

    public async appendVolume(exemplar: Exemplar): Promise<void> {
        exemplar.volume = await this.volumeDataService.get(exemplar.volumeId.toString());
    }

    public getSeriesText(document: ExtendedDocument): string {

        const getPartPrefix = () => `- ${this.localizationService.get(/* @kp-localization commons.part */ 'commons.part')} `

        return document
            .getFields('787')
            .filter((field) => field.text.toLowerCase().indexOf('z cyklu') !== -1)
            .flatMap((field) => field.fields)
            .map((subfield) => (subfield.code === 'g' ? getPartPrefix() : '') + subfield.text)
            .join(' ');
    }

    public getSf245c(document: ExtendedDocument): Field[] {
        return document.getSubfields('245', 'c');
    }

    public getSfAltAuthors(sf245c: Field[], document: ExtendedDocument): Field[] | null {
        return sf245c.length > 0 ? null : document.getSubfields(['100', '700'], 'a');
    }
}